import { defineComponent, onMounted } from 'vue';
import PayoutOrderList from '@/layouts/payout-order-page/payout-order-list/payout-order-list';
import PayoutOrderListHeader from '@/layouts/payout-order-page/payout-order-header-list/payout-order-header-list';
import PayoutOrderListFilter from '@/layouts/payout-order-page/payout-order-list-filter/payout-order-list-filter';
import { usePayoutOrderListFilter } from '@/hooks/payout-order/payout-order-list-filter.composables';
import { usePayoutOrderList } from '@/hooks/payout-order/payout-order-list.composables';

export default defineComponent({
  name: 'PayoutOrderPage',
  components: {
    PayoutOrderListFilter,
    PayoutOrderListHeader,
    PayoutOrderList,
  },
  setup() {
    const { updateLoadedDictionaries, submitAndValidateForm } = usePayoutOrderListFilter();
    const { loadPayoutOrderList } = usePayoutOrderList();

    const updatePayoutOrderList = async (): Promise<void> => {
      updateLoadedDictionaries();

      const isFormValid: boolean = await submitAndValidateForm();

      if (!isFormValid) {
        return;
      }

      await loadPayoutOrderList();
    };

    onMounted(() => {
      updatePayoutOrderList();
    });
  },
});
